import { ActivityHistoryFilters } from '@/modules/entity-events/models/ActivityHistoryFilters.model';

export function normalizeActivityHistoryFilters(
    query: { entryType?: string[], tags?: string[], causedBy?: string },
): ActivityHistoryFilters {
    return {
        entryType: query.entryType || [],
        tags: query.tags || [],
        causedBy: query.causedBy || '',
    };
}
